import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../apiBase';
import './profile-account.css';

function authApi() {
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
}

export default function DeleteAccountSection() {
    const { t } = useTranslation('profile');
    const [showConfirm, setShowConfirm] = useState(false);
    const [password, setPassword] = useState('');
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    async function handleDelete() {
        if (!password) {
            setError(t('enterPasswordToConfirm'));
            return;
        }
        setLoading(true);
        setError('');
        try {
            await authApi().post('/auth/delete-account', { password, reason: reason || null });
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = '/';
        } catch (err) {
            setError(err.response?.data?.message || t('error'));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="sp-panel profile-account__section profile-account__danger">
            <h3 className="profile-account__title">⚠️ {t('dangerZone')}</h3>

            {!showConfirm ? (
                <div>
                    <p className="profile-account__muted">{t('deleteAccountWarning')}</p>
                    <button
                        type="button"
                        className="sp-btn sp-btn--outline profile-account__danger-btn"
                        onClick={() => setShowConfirm(true)}
                    >
                        🗑️ {t('deleteAccount')}
                    </button>
                </div>
            ) : (
                <div className="profile-account__confirm">
                    <p className="profile-account__danger-text">
                        <strong>{t('deleteAccountConfirmText')}</strong>
                    </p>
                    <p className="profile-account__muted">{t('deleteAccountDescription')}</p>

                    <select
                        className="sp-input"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    >
                        <option value="">{t('selectReason')}</option>
                        <option value="not_using">{t('reasonNotUsing')}</option>
                        <option value="privacy">{t('reasonPrivacy')}</option>
                        <option value="switching">{t('reasonSwitching')}</option>
                        <option value="other">{t('reasonOther')}</option>
                    </select>

                    {error && (
                        <div className="profile-account__alert profile-account__alert--error">{error}</div>
                    )}

                    <input
                        className="sp-input"
                        type="password"
                        placeholder={t('enterPasswordToConfirm')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                    />

                    <div className="profile-account__btn-group">
                        <button
                            type="button"
                            className="sp-btn profile-account__danger-btn--solid"
                            onClick={handleDelete}
                            disabled={loading}
                        >
                            {loading ? t('deleting') : t('confirmDelete')}
                        </button>
                        <button
                            type="button"
                            className="sp-btn sp-btn--outline"
                            onClick={() => {
                                setShowConfirm(false);
                                setPassword('');
                                setError('');
                            }}
                        >
                            {t('cancel')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
